import { ColorName } from '@shinetools/sunshine';

import {
  InvoicePaymentMention,
  InvoiceStatus,
  ParticularMention,
  QuotePaymentMention,
  QuoteStatus,
} from '__generated__/GQL';

export const getColorScheme = ({
  status,
}: {
  status: InvoiceStatus | QuoteStatus;
}): ColorName => {
  switch (status) {
    case 'SENT':
      return 'blue';
    case 'ACCEPTED':
    case 'PAID':
    case 'MARKED_AS_PAID':
      return 'green';
    case 'OVERDUE':
    case 'ARCHIVED':
      return 'red';
    default:
      return 'grey';
  }
};

export const formatSpecialMentionsInput = <
  T extends ParticularMention | InvoicePaymentMention | QuotePaymentMention,
>(
  specialMentions: T[],
): { type: T }[] => specialMentions.map((type) => ({ type }));
